import ManualSamplingTable from "./components/ManualSamplingTable";

const ManualSampling = () => {
  return (
    <>
      <ManualSamplingTable />
    </>
  );
};

export default ManualSampling;
